import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { attributeTranslations } from '@usheru-hff/sdk/attribute';

@Component({
  selector: 'ush-ui-attribute',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span [attr.data-translate]="'showtime.attribute.' + attribute">{{ translateAttribute(attribute) }}</span
    ><span class="comma">,</span>
  `,
  styleUrls: ['./ui-attribute.component.scss'],
  standalone: false
})
export class UiAttributeComponent {
  @Input() attribute: string;

  translateAttribute(att: string): string {
    return attributeTranslations[att] || att;
  }
}
